import { render, staticRenderFns } from "./notes.vue?vue&type=template&id=7f6e310a"
import script from "./notes.vue?vue&type=script&lang=ts"
export * from "./notes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports